import Component from 'component';
import _template from 'lodash/template';
import reviewsTmpl from '../templates/reviews';
import { BREAKPOINT } from '../constants';

class ReviewsListFlexible extends Component {
  constructor(el) {
    super(el);

    this.setInitialLimit();
    this.renderItems();
  }

  setupDefaults() {
    this.offset = 0;
    this.limit = this.$el.data('stepMobile');
    this.franchiseId = this.$el.data('franchiseId');
    this.endpoint = this.$el.data('endpoint');
    console.log(this.limit)

    this.dom = {
      $reviewsContainer: this.$el.find('.reviews-list__content'),
      $loadMoreBtn: this.$el.find('.reviews-list__load-more'),
      $loading: this.$el.find('.reviews-list__loading')
    };
  }

  addListeners() {
    this.dom.$loadMoreBtn.on('click', ::this.renderItems);
  }

  setInitialLimit() {
    if (window.matchMedia(`(min-width: ${BREAKPOINT.desktop}px)`).matches) {
      this.limit = this.$el.data('stepDesktop');
    } else if (window.matchMedia(`(min-width: ${BREAKPOINT.tablet}px)`).matches) {
      this.limit =this.$el.data('stepTablet');
    }
  }

  getResults() {
    return $.ajax({
      url: this.endpoint,
      data: {
        franchiseId: this.franchiseId,
        offset: this.offset,
        limit: this.limit
      }
    });
  }

  async renderItems() {
    this.dom.$loading.show();

    const results = await this.getResults();

    this.offset += this.limit;
    this.limit = 6;

    this.dom.$loading.hide();

    if (!results.success) {
      if (__DEV__) {
        console.error(results.message);
      }
      this.$el.addClass('reviews-list--no-results');

      return;
    }

    const { reviews, totalResults } = results.response;

    if (totalResults === 0) {
      this.$el.addClass('reviews-list--no-results');

      return;
    }

    for(const data of reviews) {
      this.dom.$reviewsContainer.append(_template(reviewsTmpl)(data));
    }

    if (this.dom.$reviewsContainer.children().length >= totalResults) {
      this.dom.$loadMoreBtn.css('display', 'none');
    } else {
      this.dom.$loadMoreBtn.css('display', 'block');
    }
  }
}

export default ReviewsListFlexible;



// WEBPACK FOOTER //
// ./src/pg/js/components/ReviewsListFlexible.js